var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.219 5.625a3.375 3.375 0 100 6.75 3.375 3.375 0 000-6.75zm0 5.625A2.25 2.25 0 1111.469 9a2.257 2.257 0 01-2.25 2.25zm3.094-9.281H6.125a3.937 3.937 0 00-3.938 3.937v6.188a3.938 3.938 0 003.938 3.937h6.188a3.937 3.937 0 003.937-3.937V5.906a3.937 3.937 0 00-3.938-3.937zm2.812 10.125a2.811 2.811 0 01-2.813 2.812H6.125a2.813 2.813 0 01-2.813-2.812V5.906a2.813 2.813 0 012.813-2.812h6.188a2.813 2.813 0 012.812 2.812v6.188zm-1.406-6.75a.844.844 0 11-1.688 0 .844.844 0 011.688 0z"
  })));
}
export default SvgInstagram;